import { useMutation } from "@tanstack/react-query";
import { validateAccountData } from "src/services";

interface ValidateAccountDataInputType {
  token: string;
  request: ValidateAccountDataRequestType;
}
const useValidateAccountData = () =>
  useMutation<
    ValidateAccountDataResponseType,
    AxiosFilteredError,
    ValidateAccountDataInputType
  >({
    mutationFn: ({ token, request }) => validateAccountData(token, request),
  });

export default useValidateAccountData;
